module.exports = __webpack_public_path__ + "fda3766e09cd710d8589dc330976e32b.fbx";